import { createContext } from 'react';
import { Comments } from '../networking/analyses/comments/Comments.types';

export interface CommentsProvider {
  comments: Comments;
  setComments: React.Dispatch<React.SetStateAction<Comments>>;
}

export const CommentsContext = createContext({} as CommentsProvider);
